<template>
    <div class="menu-bar">
        <button class="menu-bar__item" @click="openCatalog">
            <svg class="menu-bar__item__icon">
                <use :xlink:href="iconLink('catalog')" />
            </svg>
            <span class="menu-bar__item__text">{{ $t('catalog') }}</span>
        </button>
        <a class="menu-bar__item" :href="`tel:${mainPhoneNumber}`">
            <svg class="menu-bar__item__icon">
                <use :xlink:href="iconLink('phone')" />
            </svg>
            <span class="menu-bar__item__text">{{ $t('callNow') }}</span>
        </a>
        <a v-if="isEcaterix" class="menu-bar__item" :href="`https://online.ecaterix.md/${$i18n.locale}`" target="_blank">
            <svg class="menu-bar__item__icon">
                <use :xlink:href="iconLink('person')" />
            </svg>
            <span class="menu-bar__item__text">{{ $t('cabinet') }}</span>
        </a>
        <button class="menu-bar__item" @click="changeLocale()">
            <svg class="menu-bar__item__icon">
                <use :xlink:href="iconLink('global')" />
            </svg>
            <span class="menu-bar__item__text">{{ activeLang }}</span>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'MenuBar',
    computed: {
        ...mapGetters({
            mainPhoneNumber: 'global/mainPhoneNumber',
            isEcaterix: 'global/getIsEcaterix'
        }),
        activeLang() {
            const locale = this.$i18n.locales.find(item => item.code === this.$i18n.locale);
            return locale.name;
        }
    },
    methods: {
        changeLocale() {
            this.$router?.replace(this.switchLocalePath(this.$i18n.locale === 'ro' ? 'ru' : 'ro'));
        },
        iconLink(icon) {
            const spritePath = require('@/themes/ecaterix/assets/icons/sprite.svg');
            return `${spritePath}#${icon}`;
        },
        openCatalog() {
            this.$store.dispatch('mobile-menu/openCatalog');
        }
    }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
